import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthRoute from "./components/Auth/Routes/AuthRoute";
import RecruitmentRoutes from "./components/Employee/Recruitment/RecruitmentLayout/Routes/RecruitmentRoutes";
import ProtectedRoute from "./components/Employee/Recruitment/ProtectedRoutes/ProtectedRoute";
import InactiveUser from "../src/components/Common/AccessControl/InactiveUser";
import AdminRoutes from "./components/Admin/routes/AdminRoutes";
import DealRoutes from "./components/Employee/Recruitment/RecruitmentLayout/Routes/DealRoutes";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthRoute />} />
        <Route path="/inactive-user" element={<InactiveUser />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <RecruitmentRoutes />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/deals/*"
          element={
            <ProtectedRoute>
              <DealRoutes />
            </ProtectedRoute>
          }
        />        

        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
